import React from "react";

export const PdfIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27"
    height="30"
    viewBox="0 0 27 30"
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#438d6d"
        d="M13.233 14.015h-.85v3.962h.85c1.264 0 1.977-.722 1.977-1.968s-.713-1.994-1.977-1.994"
      />
      <path
        fill="#438d6d"
        d="M21.05 13.972h-2.5v1.539h1.916v.954H18.55V19h-1.204v-6h3.705v.972zM13.276 19h-2.098v-6h2.098c1.917 0 3.163 1.187 3.163 3.009 0 1.814-1.246 2.99-3.163 2.99zm-5.118-2.303H7.153V19H5.95v-6h2.21c1.444 0 2.166.817 2.166 1.857 0 .91-.619 1.84-2.167 1.84zM18 0H2a2 2 0 0 0-2 2v26a2 2 0 0 0 2 2h23a2 2 0 0 0 2-2V8l-9-8z"
      />
      <path
        fill="#438d6d"
        d="M8.107 13.98h-.954v1.745h.954c.68 0 .98-.335.98-.868 0-.55-.3-.877-.98-.877"
      />
      <path fill="#c1dfc4" d="M18 0v6a2 2 0 0 0 2 2h7l-9-8z" />
    </g>
  </svg>
);
